import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-primary-dark py-16 px-4 border-y-4 border-gold" data-id="element-108">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109">
        <ShieldCheck className="w-20 h-20 md:w-24 md:h-24 text-gold mx-auto mb-6" data-id="element-110" />
        <h2 className="text-3xl md:text-5xl font-bold text-cream mb-6 font-serif" data-id="element-111">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <div className="space-y-4 text-lg md:text-xl text-cream/90 mb-8 font-medium" data-id="element-112">
          <p data-id="element-113">Abrís los tomos. Los aplicás a tu situación.</p>
          <p data-id="element-114">
            Si en 7 días no notás una diferencia real en tu claridad financiera
            y en tu capacidad de controlar a dónde va tu dinero:
          </p>
          <p className="font-bold text-2xl text-gold bg-black/20 inline-block px-6 py-3 rounded-xl border border-gold/30 mt-2" data-id="element-115">
            devolución del 100% sin formularios, sin drama, sin explicaciones.
          </p>
        </div>
        <div className="inline-block bg-cream text-ink px-6 py-3 rounded-full font-bold shadow-md" data-id="element-116">
          <p data-id="element-117">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </div>
    </section>;
}